<template>
  <div>
      <!-- Content -->
        <div class="row justify-content-center p-2">
          <div class="col-sm-8">

            <h1 class="text-center">Offers and Promotions</h1>

            <div class="offers-wrapper">

              <div class="tabs-container">
  <input type="radio" name="tabs" id="tab1" checked>
  <input type="radio" name="tabs" id="tab2">
  <input type="radio" name="tabs" id="tab3">

  <div class="tabs">
  <label for="tab1" class="tab-label">
    <img src="../assets/saf2.png" alt="Safaricom" style="width: 40%;margin-top: 15px;" />
    <!-- Safaricom -->
  </label>

  <label for="tab2" class="tab-label airtel">
    <img src="../assets/airtel.png" alt="Airtel" style="width: 20%;" />
    <!-- Airtel -->
  </label>

  <label for="tab3" class="tab-label">
    <p style="margin-top: 15px;">Other</p>
  </label>

  <div class="indicator"></div>
</div>

  <div class="tab-content">
    <div class="content content-1">
                   <!-- CATEGORY LOOP -->
              <div class="category-section" v-for="category in categories" :key="category.id">
                <div v-if="category.telco=='Safaricom'">
                <h3 class="category-title text-success">
                  {{ category.category_name }}
                </h3>

                <!-- OFFERS -->
                 <div class="row">

                          <div
                  class="offer-card col-sm-4"
                  v-for="offer in category.offers"
                  :key="offer.id"
                >
                  <div class="offer-left">
                    <h4 class="offer-name">{{ offer.offer_name }}</h4>
                    <p class="offer-old">
                      <!-- Was <span>Ksh {{ formatPrice(offer.old_price) }}</span> -->
                    </p>
                  </div>

                  <div class="offer-actions">
                    <span class="offer-new">
                    <span class="offer-old">Ksh {{ formatPrice(offer.old_price) }}</span>  Ksh {{ formatPrice(offer.new_price) }}
                    </span>

                    <button
                      class="buy-btn" :disabled="!offer.status" :class="{ 'btn-disabled': !offer.status }"
                      v-on:click="routerPage('offer',offer.id)"
                    >
                       {{ offer.status ? 'Buy' : 'Unavailable' }}
                    </button>
                  </div>
                </div>


                 </div>


              </div>
</div>
    </div>
    <div class="content content-2">
                   <!-- CATEGORY LOOP -->
              <div class="category-section" v-for="category in categories" :key="category.id">
                <div v-if="category.telco=='Airtel'">
                <h3 class="category-title text-danger">
                  {{ category.category_name }}
                </h3>

                <!-- OFFERS -->
                 <div class="row">
                <div
                  class="offer-card col-sm-4"
                  v-for="offer in category.offers"
                  :key="offer.id"
                >
                  <div class="offer-left">
                    <h4 class="offer-name">{{ offer.offer_name }}</h4>
                    <p class="offer-old">
                      <!-- Was <span>Ksh {{ formatPrice(offer.old_price) }}</span> -->
                    </p>
                  </div>

                  <div class="offer-actions">
                    <span class="offer-new">
                       <span class="offer-old">Ksh {{ formatPrice(offer.old_price) }}</span>  Ksh {{ formatPrice(offer.new_price) }}
                    </span>

                     <button
                      class="buy-btn" :disabled="!offer.status" :class="{ 'btn-disabled': !offer.status }"
                      v-on:click="routerPage('offer',offer.id,)"
                    >
                       {{ offer.status ? 'Buy' : 'Unavailable' }}
                    </button>
                  </div>
                </div>
</div>
              </div>
</div>
    </div>
    <div class="content content-3">
      <p>No offers Available</p>
    </div>
  </div>
</div>



            </div>

          </div>
        </div>
  </div>
</template>
<script>
    // import moment from 'moment'
    export default {
        name: 'Index',
        components: {

        },
        data(){
            return {
              message:{discount:'0',credit:'0',amount:'0',type:'bonga',receiving_no:'',source:'app'},
                role:'false',
                phone:'',
                categories:[]

            }
        },
        created(){
           this.getOffers();

        },
        methods: {
         getOffers(){
                let uri =`/api/auth/getOffers`;
                this.$axios.get(uri, { headers: { Authorization: 'Bearer '+localStorage.getItem('token')}}).then((response) => {
                   this.categories=response.data;
                }).catch(warning => {

                });
            },
               routerPage(val,id){
              this.$router.push({ name: val, params: { id } });
            },
            formatPrice(value) {
                let val = (value/1).toFixed(2).replace('.', '.');
                return val.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ",")
            }
        },
    }

</script>



// WEBPACK FOOTER //
// src/components/offers.vue